<template>
  <layout-card-wrap
    v-loading="loading"
    hasHeaderSlot>
    <template slot="title">会员等级管理 </template>
    <!-- <template slot="form">
      <el-button type="primary"
        @click="createMemberLevel">创建会员模板</el-button>
      <el-button type="primary"
        @click="addLevel"
        :disabled="list.length===4">新增会员等级</el-button>
    </template> -->
    <el-table
      border
      :data="list">
      <el-table-column
        label="等级"
        width="50">
        <template slot-scope="{row}">
          <span>{{ row.level }}</span>
        </template>
      </el-table-column>
      <el-table-column label="名称">
        <template slot-scope="{row}">
          <span>{{ row.levelName }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="会员卡片"
        width="230">
        <template slot-scope="{row}">
          <img
            :src="row.memberCardPicture"
            style="width: 200px;height: 96px;" />
        </template>
      </el-table-column>
      <el-table-column
        label="图标"
        width="60">
        <template slot-scope="{row}">
          <img
            :src="row.levelIcon"
            style="width: 30px;height: 30px;" />
        </template>
      </el-table-column>
      <el-table-column
        label="成长分"
        width="150">
        <template slot-scope="{row}">
          <span>{{ row.start==0?0:row.start+1 }}</span>~
          <span>{{ row.levelScore }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="会员折扣"
        min-width="200">
        <template slot-scope="{row, $index}">
          <div v-if="row.discount !== 10">
            <span style="vertical-align: middle;">{{ row.discount }}折</span>
            <el-popover
              :ref="`popover_${$index}_1`"
              style="margin-left:5px;vertical-align: middle;"
              trigger="click"
              placement="right"
              @show="() => {popoverShow(row, $index)}">
              <div style="margin:10px">
                <el-input-number
                  v-model="row.discountBak"
                  controls-position="right"
                  :min="0.1"
                  :max="9.9"
                  :step="0.1"></el-input-number>折
                <el-button
                  style="margin-left:10px"
                  type="primary"
                  @click="() => {updateDiscount(row,`popover_${$index}_1`)}">确定</el-button>
              </div>
              <i
                slot="reference"
                style="cursor: pointer;"
                class="el-icon-edit"></i>
            </el-popover>
            <el-switch
              style="margin-left:10px;"
              :disabled="row.discount === 10"
              :value="row.enableDiscount"
              :active-value="1"
              :inactive-value="0"
              active-text="开"
              inactive-text="关"
              @change="changeDiscount(row)">
            </el-switch>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        :width="buildMode !== 'SH_WEB' ? 200 : 120">
        <template slot-scope="{row, $index}">
          <el-button
            type="text"
            style="vertical-align: middle;"
            @click="uppdateMemberLevel(row)">修改</el-button>
          <!-- <el-button type="text"
            :disabled="$index !== list.length - 1"
            @click="deleteMemberLevel(row)">删除</el-button> -->
          <el-popover
            v-if="row.discount === 10"
            :ref="`popover_${$index}_2`"
            style="margin-left:5px;vertical-align: middle;"
            trigger="click"
            placement="right"
            @show="() => {popoverShow(row, $index)}">
            <div style="margin:10px">
              <el-input-number
                v-model="row.discountBak"
                controls-position="right"
                :min="0.1"
                :max="9.9"
                :step="0.1"></el-input-number>折
              <el-switch
                v-model="row.enableDiscountBak"
                style="margin-left:10px;"
                :active-value="1"
                :inactive-value="0"
                active-text="开"
                inactive-text="关">
              </el-switch>
              <el-button
                style="margin-left:10px"
                type="primary"
                @click="() => {updateDiscount(row,`popover_${$index}_2`)}">确定</el-button>
            </div>
            <el-button
              slot="reference"
              type="text">新增折扣</el-button>
          </el-popover>
          <el-button
            v-if="buildMode !== 'SH_WEB'"
            type="text"
            style="vertical-align: middle;margin-left: 10px;"
            @click="VipUpgrade(row)">晋升及权益</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      :title="`编辑会员等级`"
      :visible.sync="dialogVisible"
      width="500px"
      @closed="handleClosed">
      <el-form
        ref="form"
        label-width="120px"
        :model="form"
        :rules="rules">
        <el-form-item
          label="等级名称"
          prop="levelName">
          <el-input v-model="form.levelName"></el-input>
        </el-form-item>
        <el-form-item
          label="成长分值上限"
          prop="levelScore">
          <el-input-number
            v-model="form.levelScore"
            :precision="0"></el-input-number>
        </el-form-item>
        <el-form-item
          label="会员卡"
          prop="memberCardPicture">
          <upload-with-crop
            v-model="form.memberCardPicture"
            :cropper="true"
            :fixedNumber="[200,96]"
            :autoCropWidth="300"
            :autoCropHeight="144" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <!-- <el-button type="primary"
          v-if="modal.editType === 'add'"
          @click="submitForm">确 定</el-button> -->
        <el-button
          type="primary"
          @click="updateMemberLevelSubmit">确 定</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>

    <vip-upgrade-modal
      ref="vip"
      @fetch="fetchMemberLevels" />
  </layout-card-wrap>
</template>
<script>
import UploadWithCrop from '@/components/wx/upload-with-crop.vue'
import VipUpgradeModal from './vip-upgrade-modal/vip-upgrade-modal.vue'
export default {
  name: 'MemberLevelTable',
  components: { UploadWithCrop, VipUpgradeModal },
  props: {
    vendorId: [String, Number],
    callback: Function
  },
  data() {
    return {
      buildMode: process.env.VUE_APP_BUILD_MODE,
      init: true,
      loading: false,
      memberLevelFlag: false,
      list: [],
      modal: {
        // editType: '',
        start: 0,
        end: 0
      },
      form: {
        levelId: null,
        levelName: null,
        levelScore: null,
        levelIcon: null,
        memberCardPicture: []
      },
      dialogVisible: false,
      rules: {
        levelName: [
          { required: true, message: '请输入等级名称', trigger: 'blur' },
          { min: 2, max: 6, message: '长度在 2 到 6 个字符', trigger: 'blur' }
        ],
        levelScore: [
          { required: true, message: '请输入成长分值', trigger: 'blur' }
        ],
        memberCardPicture: [
          { required: true, message: '请上传会员卡', trigger: 'change' }
        ]

      }
    }
  },
  mounted() {
    // this.fetchMemberLevels()
    this.createMemberLevel()
  },
  methods: {
    VipUpgrade(row) {
      const { levelAmount, shopIncentiveSteps, levelUpgradeGiveAmount } = row
      console.log({ levelAmount, shopIncentiveSteps, levelUpgradeGiveAmount })
      this.$refs.vip.init({ levelAmount: levelAmount || 0, levelUpgradeGiveAmount, shopIncentiveSteps: shopIncentiveSteps || [] }, row)
    },
    popoverShow(row, $index) {
      row.enableDiscountBak = row.enableDiscount
      row.discountBak = row.discount
      this.list.splice($index, 1, row)
    },
    handleClosed() {
      this.$refs['form'].resetFields()
    },
    createMemberLevel() {
      this.$store.dispatch('member/creatememberlevelfromtemplate', {
        payload: {
          vendorId: this.vendorId
        },
        success: () => {
          this.callback && this.callback()
          this.fetchMemberLevels()
        },
        fail: () => { }
      })
    },
    addLevel() {
      this.$store.dispatch('member/getmemberleveltemplate', {
        payload: {
          vendorId: this.vendorId,
          level: this.list.length + 1
        },
        success: res => {
          // this.modal.editType = 'add'
          this.modal.start = this.list[this.list.length - 1].levelScore
          this.modal.end = 100000
          this.form.levelId = null
          this.form.levelName = res.data.levelName
          this.form.levelScore = res.data.levelScore
          this.form.levelIcon = res.data.levelIcon
          this.form.memberCardPicture = [{ url: res.data.memberCardPicture }]
          this.dialogVisible = true
        },
        fail: () => { }
      })
    },
    submitForm() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.$store.dispatch('member/addmemberlevel', {
            payload: {
              vendorId: this.vendorId,
              level: this.list.length + 1,
              ...this.form,
              memberCardPicture: this.form.memberCardPicture.map(i => i.url).join(',')
            },
            success: () => {
              this.dialogVisible = false
              this.fetchMemberLevels()
            },
            fail: () => { }
          })
        }
      })
    },
    deleteMemberLevel(row) {
      this.$confirm('您确定删除该会员等级?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$store.dispatch('member/deletememberlevel', {
            payload: {
              vendorId: row.vendorId,
              levelId: row.levelId
            },
            success: () => {
              this.fetchMemberLevels()
            },
            fail: () => { }
          })
        })
    },
    uppdateMemberLevel(row) {
      // this.modal.editType = 'update'
      this.modal.start = row.start
      this.modal.end = row.end
      this.form.levelId = row.levelId
      this.form.levelName = row.levelName
      this.form.levelScore = row.levelScore
      this.form.levelIcon = row.levelIcon
      this.form.memberCardPicture = [{ url: row.memberCardPicture }]
      this.dialogVisible = true
    },
    updateMemberLevelSubmit() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.$store.dispatch('member/updatememberlevel', {
            payload: {
              vendorId: this.vendorId,
              ...this.form,
              memberCardPicture: this.form.memberCardPicture.map(i => i.url).join(',')
            },
            success: () => {
              this.dialogVisible = false
              this.fetchMemberLevels()
            },
            fail: () => { }
          })
        }
      })
    },
    updateDiscount(row, _ref) {
      this.loading = true
      this.$store.dispatch('member/updatememberlevel', {
        payload: {
          vendorId: row.vendorId,
          discount: row.discountBak,
          levelId: row.levelId,
          enableDiscount: row.enableDiscountBak
        },
        success: () => {
          this.loading = false
          // eslint-disable-next-line no-underscore-dangle
          this.$refs[_ref].doClose()
          this.fetchMemberLevels()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    changeDiscount(row) {
      this.loading = true
      this.$store.dispatch('member/updatememberlevel', {
        payload: {
          vendorId: row.vendorId,
          levelId: row.levelId,
          discount: row.discount,
          enableDiscount: row.enableDiscount === 0 ? 1 : 0
        },
        success: () => {
          this.loading = false
          this.fetchMemberLevels()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    fetchMemberLevels() {
      this.loading = true
      this.$store.dispatch('member/getmemberlevels', {
        payload: {
          vendorId: this.vendorId
        },
        success: res => {
          this.loading = false
          res.data.records.reduce(function(pre, cur) {
            cur.start = pre.levelScore
            return cur
          }, { levelScore: 0 })
          this.list = res.data.records.map((item, i) => {
            item.end = item.levelScore
            if (i === res.data.records.length - 1) {
              item.end = 1000000
            }
            item.rate = 100
            item.enableDiscountBak = item.enableDiscount
            item.discountBak = item.discount
            return item
          })
          // if (res.data.result === 0) {
          //   // this.memberLevelFlag = false
          //   if (this.init) {
          //     this.init = false
          //     this.callback && this.callback()
          //   }
          // } else {
          //   // this.memberLevelFlag = true
          //   this.createMemberLevel()
          // }
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
